export default __webpack_public_path__ + "static/media/DSC_0263@2x.f2a623b8.png";